// Helper centralizado para status de exame (SOLICITACAO_EXAMES.SITUACAO)
// Status reais no banco: P, M, D, F, I, E

export const situacaoExameMap = {
  P: 'Pendente',
  M: 'Parcial',
  D: 'Digitado',
  F: 'Falta conferir',
  I: 'Impresso',
  E: 'Entregue',
};

// Cores para badges/chips (color = texto, bg = fundo)
export const situacaoExameCores = {
  P: { color: '#666', bg: '#f5f5f5' },
  M: { color: '#e65100', bg: '#fff3e0' },
  D: { color: '#1565c0', bg: '#e3f2fd' },
  F: { color: '#7b1fa2', bg: '#f3e5f5' },
  I: { color: '#2e7d32', bg: '#e8f5e9' },
  E: { color: '#2e7d32', bg: '#e8f5e9' },
};

/** Retorna label legível do código de situação */
export const situacaoExameLabel = (code) => {
  const trimmed = (code || '').trim();
  return situacaoExameMap[trimmed] || trimmed || '-';
};

/** Retorna {color, bg} para usar em badges. Fallback: cinza neutro */
export const situacaoExameStyle = (code) => {
  const trimmed = (code || '').trim();
  return situacaoExameCores[trimmed] || { color: '#999', bg: '#f5f5f5' };
};
